import type { HubAnnotationArtifact } from '@robovision/hub'
import { JobBaseArtifactWithoutDefinition } from './JobBaseArtifact'


export interface JobAnnotationArtifactParams extends JobBaseArtifactWithoutDefinition {
  datapoolId: string
}

export class JobAnnotationArtifact extends JobBaseArtifactWithoutDefinition {
  public datapoolId: string

  protected constructor (params: JobAnnotationArtifactParams) {
    super(params)
    this.datapoolId = params.datapoolId
  }

  public static fromDefinition (
    annotationArtifact: HubAnnotationArtifact,
  ) {
    return new JobAnnotationArtifact({
      artifactId: annotationArtifact.id,
      datapoolId: annotationArtifact.datapoolId,
      description: annotationArtifact.description,
      name: annotationArtifact.name,
    })
  }
}
